/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_link_minecraft_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link Minecraft Account`)
};

const zh_hans1_link_minecraft_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`绑定 Minecraft 账号`)
};

const zh_hant1_link_minecraft_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`綁定 Minecraft 帳號`)
};

const fr_link_minecraft_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lier un compte Minecraft`)
};

const de_link_minecraft_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft-Konto verknüpfen`)
};

const ja_link_minecraft_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft アカウント連携`)
};

const ko_link_minecraft_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft 계정 연동`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const link_minecraft_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.link_minecraft_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("link_minecraft_title", locale)
	if (locale === "en") return en_link_minecraft_title(inputs)
	if (locale === "zh-Hans") return zh_hans1_link_minecraft_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_link_minecraft_title(inputs)
	if (locale === "fr") return fr_link_minecraft_title(inputs)
	if (locale === "de") return de_link_minecraft_title(inputs)
	if (locale === "ja") return ja_link_minecraft_title(inputs)
	return ko_link_minecraft_title(inputs)
};